import { ELocalStorageKeys } from '../constants/enums';
import { localStorageUtil } from '../utils/localStorageUtil';

const MOCK_URL = 'https://api-dev.appcharge.com/mock/mock';

export const fetchConfig = {
  general: {
    refetchOnWindowFocus: false
  },
  list: {
    refetchOnWindowFocus: false
  },
  single: {
    refetchOnWindowFocus: false,
    enabled: false
  }
};

export enum EApiRoutes {
  PLANS = 'PLANS',
  COUPONS = 'COUPONS',
  COUPONS_CONFIGURATION = 'COUPONS_CONFIGURATION',
  CHECKLIST_TASKS = 'CHECKLIST_TASKS',
  SELF_SERVE_VERIFY_BUSINESS = 'SELF_SERVE_VERIFY_BUSINESS',
  SELF_SERVE_SEND_AGREEMENT = 'SELF_SERVE_SEND_AGREEMENT',
  TEMPLATES_STUDIO = 'TEMPLATES_STUDIO',
  PROMO_CODE = 'PROMO_CODE',
  USERS = 'USERS',
  ADD_USER = 'ADD_USER',
  ADD_USER_TO_PORTAL = 'ADD_USER_TO_PORTAL',
  UPDATE_USER_ROLE = 'UPDATE_USER_ROLE',
  DELETE_USER = 'DELETE_USER',
  RESET_USER = 'RESET_USER',
  UPDATE_USER_PASSWORD = 'UPDATE_USER_PASSWORD',
  FORGOT_USER_PASSWORD = 'FORGOT_USER_PASSWORD',
  LOGIN_USER = 'LOGIN_USER',
  LOGIN_USER_GOOGLE = 'LOGIN_USER_GOOGLE',
  LOGIN_USER_MICROSOFT = 'LOGIN_USER_MICROSOFT',
  LOGIN_USER_TOKEN = 'LOGIN_USER_TOKEN',
  LOGOUT_USER = 'LOGOUT_USER',
  RESEND_USER_INVITATION = 'RESEND_USER_INVITATION',
  MFA_AUTHENTICATE = 'MFA_AUTHENTICATE',
  MFA_VERIFY = 'MFA_VERIFY',
  MFA_SKIP = 'MFA_SKIP',
  MFA_RESEND = 'MFA_RESEND',
  BUNDLES = 'BUNDLES',
  DUPLICATE_BUNDLE = 'DUPLICATE_BUNDLE',
  DELETE_IMAGES = 'DELETE_IMAGES',
  DELETE_IMAGES_V2 = 'DELETE_IMAGES_V2',
  IMAGES = 'IMAGES',
  IMAGES_V2 = 'IMAGES_V2',
  INTEGRATION = 'INTEGRATION',
  PROFILES = 'PROFILES',
  TOGGLE_PROFILES = 'TOGGLE_PROFILES',
  ORDERS = 'ORDERS',
  CURRENCIES = 'CURRENCIES',
  SUPPORTED_CURRENCIES = 'SUPPORTED_CURRENCIES',
  DISABLED_CURRENCIES = 'DISABLED_CURRENCIES',
  FINANCIAL_CONFIGURATION = 'FINANCIAL_CONFIGURATION',
  DISABLE_CURRENCIES = 'DISABLE_CURRENCIES',
  ORDER_DETAILS = 'ORDER_DETAILS',
  PLAYERS = 'PLAYERS',
  PLAYER = 'PLAYER',
  BLOCKED_PLAYERS = 'BLOCKED_PLAYERS',
  DELETE_PLAYERS = 'DELETE_PLAYERS',
  ADD_PLAYERS_LIST = 'ADD_PLAYERS_LIST',
  POST_IMAGE_V2 = 'POST_IMAGE_V2',
  PRODUCT_QUANTITY_FORMAT = 'PRODUCT_QUANTITY_FORMAT',
  PRODUCTS = 'PRODUCTS',
  PRICING = 'PRICING',
  PRICING_META = 'PRICING_META',
  PRICE_POINT = 'PRICE_POINT',
  PUBLISHER = 'PUBLISHER',
  PUBLISHER_SETTINGS = 'PUBLISHER_SETTINGS',
  EXCHANGE_RATES_THRESHOLDS = 'EXCHANGE_RATES_THRESHOLDS',
  PUBLISHER_USERS = 'PUBLISHER_USERS',
  SEGMENTS = 'SEGMENTS',
  PUBLISHER_TAGS = 'PUBLISHER_TAGS',
  GRAPHS = 'GRAPHS',
  BARS = 'BARS',
  PIES = 'PIES',
  STATS = 'STATS',
  THEME = 'THEME',
  GENERAL_THEME = 'GENERAL_THEME',
  STORE_SCREEN = 'STORE_SCREEN',
  LOGIN_THEME = 'LOGIN_THEME',
  CHECKOUT_THEME = 'CHECKOUT_THEME',
  COMPLETED_THEME = 'COMPLETED_THEME',
  RECEIPT_THEME = 'RECEIPT_THEME',
  GEO = 'GEO',
  REFUND = 'REFUND',
  PAYMENTS = 'PAYMENTS',
  OFFERS_UI = 'OFFERS_UI',
  CHECKOUT_DESIGNS = 'CHECKOUT_DESIGNS',
  BADGES = 'BADGES',
  GET_BADGES = 'GET_BADGES',
  OFFERS = 'OFFERS',
  POPUP_OFFERS = 'POPUP_OFFERS',
  FINANCIAL_REPORTS = 'FINANCIAL_REPORTS',
  DISPUTES = 'DISPUTES',
  SECTIONS = 'SECTIONS',
  UPSERT_SECTIONS = 'UPSERT_SECTIONS',
  TABS = 'TABS',
  UPSERT_TABS = 'UPSERT_TABS',
  PAYOUTS = 'PAYOUTS',
  FEATURE_FLAGS = 'FEATURE_FLAGS',
  PRICING_POINTS_TEMPLATE = 'PRICING_POINTS_TEMPLATE',
  ROLES = 'ROLES',
  LOCALIZATION_TRANSLATIONS = 'LOCALIZATION_TRANSLATIONS',
  GENERATE_DEEPLINK = 'GENERATE_DEEPLINK',
  PAGES = 'PAGES',
  PAGES_EDIT_BLOCKS = 'PAGES_EDIT_BLOCKS',
  CONTENT_MANAGEMENT = 'CONTENT_MANAGEMENT',
  PORTAL_SETTINGS = 'PORTAL_SETTINGS',
  DISTRIBUTION_MANAGER = 'DISTRIBUTION_MANAGER',
  CHEATS = 'CHEATS',
  EXCHANGE_RATES_UPDATE_SCHEDULER = 'EXCHANGE_RATES_UPDATE_SCHEDULER',
  SELF_SERVE_SIGNUP = 'SELF_SERVE_SIGNUP',
  SELF_SERVE_SIGNUP_GOOGLE = 'SELF_SERVE_SIGNUP_GOOGLE',
  SELF_SERVE_SIGNUP_RESEND_CONFIRMATION_EMAIL = 'SELF_SERVE_SIGNUP_RESEND_CONFIRMATION_EMAIL',
  INIT_PROJECT = 'INIT_PROJECT',
  SELF_SERVE_SIGNUP_VERIFY_USER = 'SELF_SERVE_SIGNUP_VERIFY_USER',
  SUBSCRIPTIONS = 'SUBSCRIPTIONS',
  PUBLISHER_DASHBOARD_ACTIVITIES = 'PUBLISHER_DASHBOARD_ACTIVITIES',
  PRE_LOGIN_DASHBOARD_ACTIVITIES = 'PRE_LOGIN_DASHBOARD_ACTIVITIES',
  PORTAL_THUMBNAIL_IMAGE = 'PORTAL_THUMBNAIL_IMAGE',
  PROJECT_THUMBNAIL_IMAGE = 'PROJECT_THUMBNAIL_IMAGE',
  PORTAL_TAGS = 'PORTAL_TAGS',
  PUBLISHER_INTEGRATION_TEST = 'PUBLISHER_INTEGRATION_TEST'
}

export const ApiRoutes: Record<EApiRoutes, string> = {
  COUPONS: '/dashboard/coupons',
  COUPONS_CONFIGURATION: '/dashboard/coupons/configuration',
  PLANS: '/dashboard/subscriptions/plans',
  SUBSCRIPTIONS: '/dashboard/subscriptions',
  PROMO_CODE: '/dashboard/coupons/promoCode',
  CHECKLIST_TASKS: '/dashboard/publisher/onboard/tasks',
  SELF_SERVE_VERIFY_BUSINESS: '/dashboard/publisher/onboard/verify-business',
  SELF_SERVE_SEND_AGREEMENT: '/dashboard/self-serve/contract',
  TEMPLATES_STUDIO: '/dashboard/templates-studio',
  USERS: '/dashboard/v2/user/me',
  ADD_USER: '/dashboard/v2/user/invite',
  ADD_USER_TO_PORTAL: '/dashboard/v2/user/invite/portal',
  UPDATE_USER_ROLE: '/dashboard/v2/user',
  DELETE_USER: '/dashboard/v2/user',
  RESET_USER: '/dashboard/user/password/reset',
  UPDATE_USER_PASSWORD: '/dashboard/user/password/update',
  FORGOT_USER_PASSWORD: '/dashboard/user/password/forgot',
  LOGIN_USER: '/dashboard/user/login',
  LOGIN_USER_GOOGLE: '/dashboard/user/login/google',
  LOGIN_USER_MICROSOFT: '/dashboard/user/login/microsoft',
  LOGIN_USER_TOKEN: '/dashboard/user/login/token',
  LOGOUT_USER: '/dashboard/user/logout',
  RESEND_USER_INVITATION: '/dashboard/v2/user/reinvite',
  MFA_AUTHENTICATE: '/dashboard/v2/user/mfa/initiate',
  MFA_VERIFY: '/dashboard/v2/user/mfa/verify',
  MFA_SKIP: '/dashboard/v2/user/mfa/skip',
  MFA_RESEND: '/dashboard/v2/user/mfa/resend',
  BUNDLES: '/api/offersets',
  DUPLICATE_BUNDLE: '/api/offersets/duplicate',
  DELETE_IMAGES: '/dashboard/media',
  DELETE_IMAGES_V2: '/dashboard/media/v2',
  IMAGES: '/dashboard/media',
  IMAGES_V2: 'dashboard/media/v2',
  INTEGRATION: '/dashboard/integration',
  PROFILES: '/dashboard/profiles',
  TOGGLE_PROFILES: '/dashboard/profiles/toggle',
  ORDERS: '/dashboard/v2/order',
  CURRENCIES: '/dashboard/order/currencies',
  SUPPORTED_CURRENCIES: '/dashboard/financial/supported-currencies',
  DISABLED_CURRENCIES: '/dashboard/financial/disabled-currencies',
  FINANCIAL_CONFIGURATION: '/dashboard/financial/configuration',
  ORDER_DETAILS: '/dashboard/order',
  PLAYER: '/api/tags',
  PLAYERS: '/api/tags?full_details=true',
  BLOCKED_PLAYERS: '/dashboard/blocked-players',
  DELETE_PLAYERS: '/api/tags/list/deleteBatch',
  ADD_PLAYERS_LIST: '/api/tags/batch',
  POST_IMAGE_V2: 'dashboard/media/v2/upload',
  PRODUCTS: '/dashboard/product',
  PRICING: '/dashboard/pricing',
  PRICING_META: '/dashboard/pricing/pricing-meta',
  PRICE_POINT: '/dashboard/pricing/pricePoint',
  PUBLISHER: '/dashboard/publisher',
  PUBLISHER_SETTINGS: '/dashboard/publisher/publisher-settings',
  EXCHANGE_RATES_THRESHOLDS: '/dashboard/publisher/exchange-rates-thresholds',
  PUBLISHER_USERS: '/dashboard/v2/users',
  SEGMENTS: '/dashboard/segment',
  PUBLISHER_TAGS: '/dashboard/offer-tags',
  GRAPHS: '/analytics/graphs',
  BARS: '/analytics/bars',
  PIES: '/analytics/pies',
  STATS: '/analytics/stats',
  THEME: '/dashboard/storeTheme',
  GENERAL_THEME: '/dashboard/storeTheme/general',
  STORE_SCREEN: '/dashboard/storeTheme/store-screen',
  LOGIN_THEME: '/dashboard/storeTheme/login-screen',
  CHECKOUT_THEME: '/dashboard/checkoutTheme',
  COMPLETED_THEME: '/dashboard/storeTheme/completed-screen',
  RECEIPT_THEME: '/dashboard/receiptTheme',
  GEO: '/dashboard/financial/geo',
  REFUND: '/dashboard/order/refund',
  PAYMENTS: '/dashboard/financial/payment-methods',
  DISABLE_CURRENCIES: '/dashboard/publisher/update-disabled-currencies',
  OFFERS_UI: '/dashboard/offerUI',
  CHECKOUT_DESIGNS: '/dashboard/checkout-designs',
  BADGES: '/dashboard/badge',
  GET_BADGES: '/dashboard/badges',
  OFFERS: '/dashboard/offer',
  POPUP_OFFERS: '/dashboard/offer/popup/daily-bonus',
  FINANCIAL_REPORTS: '/dashboard/v2/report',
  PRODUCT_QUANTITY_FORMAT: '/dashboard/offer/format-product-quantity',
  DISPUTES: '/dashboard/disputes',
  SECTIONS: '/dashboard/sections',
  UPSERT_SECTIONS: '/dashboard/sections/upsert',
  TABS: '/dashboard/tabs',
  UPSERT_TABS: '/dashboard/tabs/upsert',
  PAYOUTS: '/dashboard/v2/payouts',
  ROLES: '/dashboard/v2/user/roles',
  FEATURE_FLAGS: 'dashboard/dashboard-settings',
  PRICING_POINTS_TEMPLATE: '/dashboard/pricing/download',
  LOCALIZATION_TRANSLATIONS: '/dashboard/translations',
  GENERATE_DEEPLINK: '/dashboard/offer',
  PAGES: '/dashboard/portal/pages',
  PAGES_EDIT_BLOCKS: '/dashboard/portal/pages/edit-blocks',
  CONTENT_MANAGEMENT: '/dashboard/portal/contents',
  PORTAL_SETTINGS: '/dashboard/portal/settings',
  DISTRIBUTION_MANAGER: '/dashboard/app-distribution-manager',
  CHEATS: '/dashboard/cheats/player',
  EXCHANGE_RATES_UPDATE_SCHEDULER:
    '/dashboard/publisher/exchange-rates-scheduler',
  SELF_SERVE_SIGNUP: '/dashboard/self-serve/signup',
  SELF_SERVE_SIGNUP_GOOGLE: '/dashboard/self-serve/signup/google',
  SELF_SERVE_SIGNUP_RESEND_CONFIRMATION_EMAIL:
    '/dashboard/self-serve/verification-email',
  INIT_PROJECT: '/dashboard/self-serve/init-project',
  SELF_SERVE_SIGNUP_VERIFY_USER: '/dashboard/v2/user',
  PUBLISHER_DASHBOARD_ACTIVITIES:
    '/dashboard/events/publisher-dashboard-activities',
  PRE_LOGIN_DASHBOARD_ACTIVITIES:
    '/dashboard/events/pre-login-dashboard-activities',
  PORTAL_THUMBNAIL_IMAGE: '/dashboard/portal/portal-thumbnail-image',
  PROJECT_THUMBNAIL_IMAGE: '/dashboard/publisher/project-thumbnail-image',
  PORTAL_TAGS: '/dashboard/portal/tags',
  PUBLISHER_INTEGRATION_TEST: '/dashboard/publisher-integration-test'
};

export const getApiRouteOrMock = (route: EApiRoutes): string => {
  if (process.env.NODE_ENV === 'production') {
    return ApiRoutes[route];
    // return
  } else {
    const mockApis = localStorageUtil.get<Partial<typeof ApiRoutes>>(
      ELocalStorageKeys.MOCK_API
    );
    if (mockApis && mockApis[route]) {
      return `${MOCK_URL}${ApiRoutes[route]}` as string;
    }
    return ApiRoutes[route];
  }
};

export const getCustomHeader = (publisherId?: string, portalId?: string): Record<string, string> | undefined => {
  if (publisherId) {
    return { 'x-publishers': publisherId };
  }
  if (portalId) {
    return { 'x-portal': portalId };
  }
  return undefined;
};
